import { createContext } from "react";
import useReportPreviewById from "../hooks/data/useReportPreviewById";

export interface IReportPreviewContext extends ReturnType<typeof useReportPreviewById> {

};

const ReportPreviewContext = createContext<IReportPreviewContext>({
    data: undefined,
    error: undefined,
    loading: true,
    validating: true,
    mutate: async () => { return undefined },
    refresh: async () => { return undefined },
});

export default ReportPreviewContext